<script setup>
import {onMounted} from "vue";
import AddressRow from "./address-row.vue";
import {useAddress} from "./useContacts";
const props = defineProps({
  url: String,
})

const {addresses, refresh} = useAddress(props.url)
onMounted(() => refresh())
</script>

<template>
  <modal title="Select Addresses" height="350px">
    <b-list-group-item v-for="address in addresses" :key="address.id" button @click="$root.$emit('submit', address)" class="p-2">
      <address-row :address="address" no-copy />
    </b-list-group-item>
  </modal>
</template>

<style scoped>

</style>